export const NEXT = 'next'
export const PREVIOUS = 'previous'



// WEBPACK FOOTER //
// ./src/components/AudioPlayer/model/constants/WhichObject.js